import { useState } from 'react';
import { ArrowLeft, ArrowRight, CheckCircle2, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';
import { AuthPageFrame } from '../../components/auth/AuthPageFrame';
import { useAuth } from '../../hooks/useAuth';

export function ForgotPasswordPage() {
  const showcaseVideo = 'https://res.cloudinary.com/ubunifu/video/upload/v1607186910/pexels-rodnae-productions-5923291_jd1rwl.mp4';
  const { requestPasswordReset } = useAuth();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  async function onSubmit(event) {
    event.preventDefault();
    setError('');
    setLoading(true);
    try {
      await requestPasswordReset(email);
      setSent(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <AuthPageFrame
      eyebrow="Password recovery"
      title={sent ? 'Check your inbox.' : 'Reset your password.'}
      description={sent ? `We sent a secure reset link to ${email}.` : 'Enter the email you use for SmartCampus and we’ll send you a reset link.'}
      showcaseVideo={showcaseVideo}
      footer={<Link className="smart-auth-back-link" to="/login"><ArrowLeft size={16} /> Back to log in</Link>}
    >
      {sent ? (
        <div className="smart-auth-success">
          <CheckCircle2 size={31} aria-hidden="true" />
          <h2>Reset email sent</h2>
          <p>Use the link in the email to choose a new password. It may take a minute to arrive.</p>
          <button className="smart-auth-submit" type="button" onClick={() => setSent(false)}>Send another link <ArrowRight size={19} /></button>
        </div>
      ) : (
        <form className="smart-auth-form" onSubmit={onSubmit}>
          {error ? <div className="smart-auth-alert" role="alert">{error}</div> : null}
          <label className="smart-auth-field" htmlFor="email">
            <span>Email</span>
            <div><Mail size={18} aria-hidden="true" /><input id="email" type="email" autoComplete="email" placeholder="name@example.com" required value={email} onChange={(event) => setEmail(event.target.value)} /></div>
          </label>
          <button className="smart-auth-submit" type="submit" disabled={loading}>{loading ? 'Sending reset link…' : <>Send reset link <ArrowRight size={19} /></>}</button>
        </form>
      )}
    </AuthPageFrame>
  );
}
